module.exports = "/assets/data/e8e828cbea4c0c184e9707aecbf230ed-EC2R.data.json";